import comp from "./MessageComponent";
export default comp;
